import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="app-footer">
      <p>© 2025 Terabase Energy. All rights reserved.</p>
      <p>Terrain Pro API Documentation</p>
    </footer>
  );
};

export default Footer;


